const updates = [
  { id: 1, date: '07.29', tag: '更新', text: '《银河远征队》第 128 话「黑洞边缘」已更新，帝国舰队首次直面奇点危机', type: 'update' },
  { id: 2, date: '07.29', tag: '新作', text: '全新连载《星际流浪者》今日上线，讲述一位孤独赏金猎人在银河边缘的冒险故事', type: 'new' },
  { id: 3, date: '07.28', tag: '更新', text: '《星球大战：新纪元》第 90 话已更新，绝地武士团面临前所未有的挑战', type: 'update' },
  { id: 4, date: '07.28', tag: '公告', text: '星球漫画阅读器全新升级，下拉式阅读体验更流畅，支持夜间模式', type: 'notice' },
  { id: 5, date: '07.27', tag: '更新', text: '《深空迷航》第 57 话已更新，探险队发现神秘外星飞船残骸', type: 'update' },
  { id: 6, date: '07.27', tag: '活动', text: '「盛夏科幻季」专题活动上线，精选百部经典科幻漫画限时推荐', type: 'event' },
  { id: 7, date: '07.26', tag: '更新', text: '《红色家园》第 34 话已更新，火星殖民地遭遇罕见沙暴袭击', type: 'update' },
  { id: 8, date: '07.26', tag: '新作', text: '新人作者力作《量子深渊》上线，量子物理与悬疑推理的完美融合', type: 'new' },
  { id: 9, date: '07.25', tag: '公告', text: '星球漫画用户突破百万！感谢每一位星际漫画爱好者的支持与陪伴', type: 'notice' },
];

const tagColors: Record<string, string> = {
  update: 'bg-primary-100 text-primary-700',
  new: 'bg-accent-100 text-accent-700',
  notice: 'bg-secondary-100 text-secondary-700',
  event: 'bg-primary-100 text-primary-700',
};

export default function Updates() {
  return (
    <section id="updates" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            最新动态
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            漫画更新、新作上线、平台公告实时追踪
          </p>
        </div>

        <div className="relative pl-6 md:pl-8 border-l-2 border-background-200">
          {updates.map((item) => (
            <div key={item.id} className="relative mb-5 md:mb-6 last:mb-0">
              <div className="absolute -left-[25px] md:-left-[29px] top-0 w-3 h-3 rounded-full bg-accent-500 border-2 border-background-100"></div>
              <div className="flex items-start gap-2 md:gap-3 flex-wrap">
                <span className="text-xs text-foreground-400 whitespace-nowrap font-medium">{item.date}</span>
                <span className={`text-xs font-semibold px-2 py-0.5 rounded-full whitespace-nowrap ${tagColors[item.type]}`}>
                  {item.tag}
                </span>
              </div>
              <p className="text-sm md:text-base text-foreground-700 mt-1.5 leading-relaxed">
                {item.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}